import { ReactNode, createContext, useState } from 'react'

interface InitContextProps {
  showOnlySelected: boolean
  updateShowOnlySelected: (value: boolean) => void
}

export const ListViewContext = createContext({} as InitContextProps)

interface ListViewContextProps {
  children: ReactNode
}

export const ListViewProvider = ({ children }: ListViewContextProps) => {
  const [showOnlySelected, setShowOnlySelected] = useState<boolean>(false)

  const updateShowOnlySelected = (value: boolean) => {
    setShowOnlySelected(value)
  }

  const value = {
    showOnlySelected,
    updateShowOnlySelected,
  }

  return (
    <ListViewContext.Provider value={value}>
      {children}
    </ListViewContext.Provider>
  )
}
